<script setup lang="ts">
const props = defineProps({
  id: { type: String, required: true },
});
</script>

<template>
  <p aria-live="assertive" class="text-[#D23232] mt-2" :id="props.id">
    <slot />
  </p>
</template>
